import { render, staticRenderFns } from "./applicant-dashboard.vue?vue&type=template&id=1fc39601"
import script from "./applicant-dashboard.vue?vue&type=script&lang=js"
export * from "./applicant-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports